module.exports = __webpack_public_path__ + "static/img/ikona_film-OFF.d7c77d12.png";